import { GetLessonWithLimitationDocument } from "@/generated/graphql";
import {
  type LessonsByParentOptions,
  getLessonsByParentIdVars,
} from "@/lib/utils/graphql/getLessonsByParentIdVars";
import { useQuery } from "@apollo/client/react";

/**
 * Fetches and paginates lessons belonging to a specific parent project
 *
 * With limitation , used for grammar canvas editor
 *
 */
export function useLessonsWithLimitation({
  parentId,
  searchText,
  sortBy,
  isTrash = false,
  skip = false,
}: LessonsByParentOptions) {
  const {
    data: lessonsByParentIdData,
    loading,
    fetchMore,
  } = useQuery(GetLessonWithLimitationDocument, {
    variables: getLessonsByParentIdVars({
      parentId,
      searchText,
      sortBy,
      isTrash,
    }),
    skip,
    fetchPolicy: "cache-first",
  });

  const items = lessonsByParentIdData?.lessonsByParentId.items ?? [];
  const hasMore = lessonsByParentIdData?.lessonsByParentId.hasMore ?? false;

  const loadMore = () => {
    fetchMore({
      variables: {
        ...getLessonsByParentIdVars({
          parentId,
          searchText,
          sortBy,
          isTrash,
        }),
        offset: items.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        return {
          lessonsByParentId: {
            ...fetchMoreResult.lessonsByParentId,
            items: [...prev.lessonsByParentId.items, ...fetchMoreResult.lessonsByParentId.items],
          },
        };
      },
    });
  };

  return {
    lessons: items,
    hasMore,
    loading,
    loadMore,
  };
}
